var map = {
	"./barring.jpg": "c612",
	"./bg.jpg": "df88",
	"./catalogue.jpg": "8055",
	"./content-bundles.jpg": "d17c",
	"./customer-contract.jpg": "6eb6",
	"./login.jpg": "e498",
	"./order.jpg": "05b1",
	"./payment-transactions.jpg": "1479",
	"./pin-protection.jpg": "9158",
	"./recharge-transactions.jpg": "7ad6",
	"./stock.jpg": "9c6f",
	"./unbarring.jpg": "3cd2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8bb";